import '../../style/';
import './index.less';
import '../../badge/style/';
